import React, { forwardRef } from 'react';
import { cn } from './cn';

/** Checkbox + (tuỳ chọn) label. Dùng @tailwindcss/forms cho base. */
export const Checkbox = forwardRef(function Checkbox({ className, label, id, description, ...props }, ref) {
  const input = (
    <input
      ref={ref}
      id={id}
      type="checkbox"
      className={cn(
        'w-4 h-4 rounded border-line-strong bg-surface-sunken text-indigo-600',
        'focus:ring-2 focus:ring-indigo-500/40 focus:ring-offset-0 cursor-pointer',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className
      )}
      {...props}
    />
  );
  if (!label) return input;
  return (
    <label htmlFor={id} className="flex items-start gap-2.5 cursor-pointer select-none">
      <span className="mt-0.5">{input}</span>
      <span>
        <span className="text-sm font-medium text-heading">{label}</span>
        {description ? <span className="block text-xs text-muted mt-0.5">{description}</span> : null}
      </span>
    </label>
  );
});

/** Radio + (tuỳ chọn) label. Nhớ truyền cùng `name` cho nhóm. */
export const Radio = forwardRef(function Radio({ className, label, id, description, ...props }, ref) {
  const input = (
    <input
      ref={ref}
      id={id}
      type="radio"
      className={cn(
        'w-4 h-4 border-line-strong bg-surface-sunken text-indigo-600',
        'focus:ring-2 focus:ring-indigo-500/40 focus:ring-offset-0 cursor-pointer',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className
      )}
      {...props}
    />
  );
  if (!label) return input;
  return (
    <label htmlFor={id} className="flex items-start gap-2.5 cursor-pointer select-none">
      <span className="mt-0.5">{input}</span>
      <span>
        <span className="text-sm font-medium text-heading">{label}</span>
        {description ? <span className="block text-xs text-muted mt-0.5">{description}</span> : null}
      </span>
    </label>
  );
});

export default Checkbox;
